import {
  linkPropertiesRepository,
  LinkPropertyData,
  UnlinkPropertyData,
} from '@/repositories/LinkPropertiesRepository'
import { BaseFilters } from '@/types'
import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useLinkProperty = (filters: BaseFilters) => {
  const queryClient = useQueryClient()
  const toast = useToast()
  const linkProperty = useMutation({
    mutationFn: async (linkPropertyData: LinkPropertyData) => {
      const response = await linkPropertiesRepository.link(linkPropertyData)
      return response.data
    },
    onError: () => {
      toast({
        title: 'Erro ao vincular propriedade.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['owner'] })
      queryClient.invalidateQueries({ queryKey: ['properties-dropdown-data'] })
      queryClient.invalidateQueries({
        queryKey: ['owners', JSON.stringify(filters)],
      })
      toast({
        title: 'Propriedade vinculada com sucesso!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  const unlinkProperty = useMutation({
    mutationFn: async (unlinkPropertyData: UnlinkPropertyData) => {
      const response = await linkPropertiesRepository.unlink(unlinkPropertyData)
      return response.data
    },
    onError: () => {
      toast({
        title: 'Erro ao desvincular propriedade.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['owner'] })
      queryClient.invalidateQueries({ queryKey: ['properties-dropdown-data'] })
      queryClient.invalidateQueries({
        queryKey: ['owners', JSON.stringify(filters)],
      })
      toast({
        title: 'Propriedade desvinculada com sucesso!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  return {
    linkPropertyAsync: linkProperty.mutateAsync,
    unlinkPropertyAsync: unlinkProperty.mutateAsync,
    isLinking: linkProperty.isPending,
    isUnlinking: unlinkProperty.isPending,
  }
}
